"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailed = exports.simple = void 0;
exports.simple = {
    HONESTY: 'Honesty-Humility',
    EMOTIONALITY: 'Emotionality',
    EXTRAVERSION: 'eXtraversion',
    AGREEABLENESS: 'Agreeableness',
    CONSCIENTIOUSNESS: 'Conscientiousness',
    OPENNESS: 'Openness to Experience',
};
exports.detailed = {
    HONESTY: 'Honesty-Humility',
    SINCERITY: 'Sincerity',
    FAIRNESS: 'Fairness',
    GREED: 'Greed-Avoidance',
    MODESTY: 'Modesty',
    EMOTIONALITY: 'Emotionality',
    FEARFULNESS: 'Fearfulness',
    ANXIETY: 'Anxiety',
    DEPENDENCE: 'Dependence',
    SENTIMENTALITY: 'Sentimentality',
    EXTRAVERSION: 'eXtraversion',
    SELF_ESTEEM: 'Social Self-Esteem',
    BOLDNESS: 'Social Boldness',
    SOCIABILITY: 'Sociability',
    LIVELINES: 'Liveliness',
    AGREEABLENESS: 'Agreeableness',
    FORGIVINGNESS: 'Forgivingness',
    GENTLENESS: 'Gentleness',
    FLEXIBILITY: 'Flexibility',
    PATIENCE: 'Patience',
    CONSCIENTIOUSNESS: 'Conscientiousness',
    ORGANISATION: 'Organization',
    DILIGENCE: 'Diligence',
    PERFECTIONISM: 'Perfectionism',
    PRUDENCE: 'Prudence',
    OPENNESS: 'Openness to Experience',
    AESTHETIC: 'Aesthetic Appreciation',
    INQUISITIVENESS: 'Inquisitiveness',
    CREATIVITY: 'Creativity',
    UNCONVENTIONALITY: 'Unconventionality',
    ALTRUISM: 'Altruism',
};
//# sourceMappingURL=hexaco.js.map